module.exports = __webpack_public_path__ + "static/media/ace5.f7620168.png";